const Dashboard = {

    // FIELDS
    "dashboard": "Dashboard",
    "asset_performance": "Asset Performance",
    "maintenance_status": "Maintenance Status",
    "recent_job_orders": "Recent Job Orders",
    "recent_employees": "Recent Employees",
    "request_graph": "Request Graph",
    "payroll_graph": "Payroll Graph",
    "downtime_analysis": "Downtime Analysis",
    
    // PAGE HEADER
    "title": "Dashboard",
    
    // TABLE HEADER
    "table_job_order": "Job Order",
    "table_asset": "Asset",
    "table_status": "Status",
    "table_date": "Date",

}

export default Dashboard;

